import React from 'react'
import { useTranslation } from 'react-i18next'
// import { makeStyles } from '@material-ui/styles'

// import styles from './styles'
import Header from './header'

// const useStyles = makeStyles(styles)

const Privacy: React.FunctionComponent<any> = () => {
	const { t } = useTranslation()

	// const classes = useStyles()

	return (
		<>
			<Header />
			{/* <div className={classes.container}> */}
			<iframe
				src={t('PrivacyDocument')} // Links for en and ro version are found in i18n files
				frameBorder="0"
				style={{
					overflow: 'hidden',
					height: '90vh',
					width: '100%',
				}}
				contentEditable={false}
				height="100vh"
				width="100%"
				title="privacy-policy"
			></iframe>
		</>
	)
}

export default Privacy
